import React from 'react';
import classNames from 'classnames';

import {Price} from 'components/__helpers/price/price';
import {DISCOUNT_PRICE} from 'features/experiments/progressiveLense/utils';

import s from './multifocalPopup.scss';

type ProgressivePriceType = {price: number; isVariantB: boolean};

/**
 * Render discount badge
 * @constructor
 */
export const DiscountBadge = () => (
    <span className={s.discountBadge}>
        <Price>{DISCOUNT_PRICE}</Price> OFF
    </span>
);

/**
 * Price block for experiment
 * @param {ProgressivePriceType} props for component
 * @constructor
 */
export const MultifocalPrice = ({price, isVariantB}: ProgressivePriceType) =>
    isVariantB ? (
        <>
            <span className={s.oldPrice}>
                +<Price>{price}</Price>
            </span>
            <span className={classNames(s.price, s.alignPrice)}>
                +<Price>{price - DISCOUNT_PRICE}</Price>
            </span>
            <DiscountBadge />
        </>
    ) : (
        <div>
            <p className={s.promo}>(Save up to $150)</p>
            <div>
                <span className={s.oldPrice}>
                    +<Price>{price}</Price>
                </span>
                <span className={s.priceC}>Starting from +$19</span>
            </div>
        </div>
    );
